import React from 'react'
import { Link } from 'react-router-dom';

export const Popular_blogs = () => {
  return (
    <div className='popular_blog_list'>
       <h4>POPULAR BLOGS</h4>
       <ol>
         <li><Link to=''>Quae cumque et sed sit aut aspernatur.</Link></li>
         <li><Link to=''>This is for new post updated</Link></li>
         <li><Link to=''>Voluptas delectus qui sunt unde debitis.</Link></li>
         <li><Link to=''>Cum enim aut ut nostrum consequuntur sit voluptas quam.</Link></li>
         <li><Link to=''>Minus soluta qui dicta natus nulla.</Link></li>
       </ol>
    </div>
  )
}

export default Popular_blogs;


